import {
  Button,
  Flex,
  Table,
  TableContainer,
  Tbody,
  Td,
  Th,
  Thead,
  Tr,
  Card,
  CardBody,
  CardHeader,
  Heading,
  useDisclosure,
  Text,
  Spacer,
  useBoolean,
  useToast,
  Tooltip,
} from "@chakra-ui/react";
import { AddIcon, DeleteIcon, EditIcon } from "@chakra-ui/icons";
import { ConfirmModal } from "../components";
import BangGiaDatAdd from "../containers/BangGiaDatAdd";
import { useEffect } from "react";
import { getBangGiaDat, saveBangGiaDat } from "../apis/giadat.api";
import { AppAction, IBangGiaDat } from "../_types_";
import React from "react";
import SearchContainer from "../components/SearchContainer";
import { getToast, subFilename } from "../utils";
import { downloadFileAsync } from "../apis/file.api";
import { toast as toast1 } from "react-toastify";
import { useGlobal } from "../contexts/Globals";

export interface IProps {}

const BangGiaDat = () => {
  const toast = useToast();
  const { isHasEditRole } = useGlobal();
  const { isOpen, onClose, onOpen } = useDisclosure();
  const [flag, setFlag] = useBoolean();

  const [flagModify, setFlagModify] = useBoolean();
  const [giaDats, setGiaDats] = React.useState<IBangGiaDat[]>([]);

  const [currentGiaDat, setCurrentGiaDat] = React.useState<IBangGiaDat>({
    id: 0,
    isDeleted: false,
    action: 0,
  });

  useEffect(() => {
    initData();
  }, []);

  const initData = async (isLichSu = false, searchKey?: string) => {
    const mdResult = await getBangGiaDat(1, 50, isLichSu, searchKey);
    setGiaDats(mdResult.items);
  };

  useEffect(() => {
    if (!flagModify) return;
    setFlagModify.off();
    setFlag.on();
  }, [currentGiaDat, flagModify, setFlag, setFlagModify]);

  const handleDownloadFile = async (
    fileId?: string | number,
    fileName?: string
  ) => {
    if (!fileId || !fileName) return;
    await downloadFileAsync(fileId, fileName);
  };

  const modifyClick = (giaDat: IBangGiaDat) => {
    setCurrentGiaDat(() => giaDat);
    if (giaDat.action === AppAction.DELETE) {
      onOpen();
    } else {
      setFlagModify.on();
    }
  };

  const handleSaveChange = async (model: IBangGiaDat) => {
    try {
      await saveBangGiaDat([model]);
      setFlag.off();
      onClose();
      initData();
      toast(
        getToast(
          `${
            model.action === AppAction.DELETE
              ? "Xoá"
              : model.action === AppAction.EDIT
              ? "Sửa"
              : "Thêm"
          } bảng giá đất thành công.`,
          "success",
          "Thông tin"
        )
      );
    } catch (er) {
      toast1.error(`${er}`, { theme: "colored" });
    }
  };

  return (
    <Flex w="full" maxW={"full"} bg="whiteAlpha.900">
      <Card w="full">
        <CardHeader>
          <Flex>
            <Heading as="h3" textTransform="uppercase">
              Bảng Giá Đất
            </Heading>
            <Spacer />
            {isHasEditRole && (
              <Button
                bg="green"
                size="sm"
                onClick={async () =>
                  modifyClick({ id: 0, isDeleted: false, action: 0 })
                }
              >
                <AddIcon color="white" />
                <Text ml="10px" color="white">
                  Thêm bảng giá đất
                </Text>
              </Button>
            )}
          </Flex>
          <Flex w="full" justifyContent="flex-end">
            <SearchContainer
              placeholder="Nhập số quyết định"
              onSearch={(s, isHis) => initData(isHis, s)}
            />
          </Flex>
        </CardHeader>
        <CardBody>
          <TableContainer w="full" overflowX="scroll">
            <Table variant="simple">
              <Thead>
                <Tr>
                  <Th>Mã</Th>
                  <Th>Số quyết định</Th>
                  <Th>Ngày ban hành</Th>
                  <Th>Cơ quan ban hành</Th>
                  <Th>Ngày hiệu lực</Th>
                  <Th>Ngày hết hiệu lực</Th>
                  <Th>Lịch sử</Th>
                  <Th>#</Th>
                  {isHasEditRole && <Th>#</Th>}
                </Tr>
              </Thead>
              <Tbody>
                {giaDats.map((giaDat) => (
                  <Tr key={giaDat.id}>
                    <Td>{giaDat.ma}</Td>
                    <Td>{giaDat.soQuyetDinh}</Td>
                    <Td>
                      {giaDat.ngayBanHanh
                        ? new Date(giaDat.ngayBanHanh).toLocaleDateString(
                            "vi-VN"
                          )
                        : ""}
                    </Td>
                    <Td>{giaDat.coQuanBanHanh}</Td>
                    <Td>
                      {giaDat.hieuLuc
                        ? new Date(giaDat.hieuLuc).toLocaleDateString("vi-VN")
                        : ""}
                    </Td>
                    <Td>
                      {giaDat.hetHieuLuc
                        ? new Date(giaDat.hetHieuLuc).toLocaleDateString(
                            "vi-VN"
                          )
                        : ""}
                    </Td>
                    <Td>{giaDat.laLichSu ? "X" : "---"}</Td>
                    <Td>
                      {giaDat.fileName && (
                        <Tooltip label={giaDat.fileName}>
                          <Button
                            variant="outline"
                            bgColor="green.50"
                            onClick={() =>
                              handleDownloadFile(giaDat.uuid, giaDat.fileName)
                            }
                          >
                            {subFilename(giaDat.fileName || "")}
                          </Button>
                        </Tooltip>
                      )}
                    </Td>
                    {isHasEditRole && (
                      <Td>
                        <Button
                          bg="red.300"
                          size="sm"
                          onClick={async () =>
                            modifyClick({ ...giaDat, action: AppAction.DELETE })
                          }
                        >
                          <DeleteIcon color="white" />
                        </Button>
                        <Button
                          bg="blue.300"
                          size="sm"
                          marginLeft="10px"
                          onClick={async () =>
                            modifyClick({ ...giaDat, action: AppAction.EDIT })
                          }
                        >
                          <EditIcon color="white" />
                        </Button>
                      </Td>
                    )}
                  </Tr>
                ))}
              </Tbody>
            </Table>
          </TableContainer>
        </CardBody>
      </Card>
      <ConfirmModal
        isOpen={isOpen}
        onClose={onClose}
        onOk={() => handleSaveChange(currentGiaDat)}
      />
      <BangGiaDatAdd
        isOpen={flag}
        onClose={() => setFlag.off()}
        currentGiaDat={currentGiaDat}
        onSave={(a) => handleSaveChange(a)}
      />
    </Flex>
  );
};

export default BangGiaDat;
